import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react';

interface PageTitle {
  content: ReactNode | string;
  subtitle?: ReactNode | string;
  link?: string | undefined;
  justNavigateBack?: boolean;
  onClick?: () => void;
}

interface PageTitleContextProps {
  pageTitle: PageTitle | undefined;
  setPageTitle: Dispatch<SetStateAction<PageTitle | undefined>>;
}

export const PageTitleContext = createContext<PageTitleContextProps>({} as PageTitleContextProps);

export function PageTitleContextProvider({ children }: { children: ReactNode }) {
  const [pageTitle, setPageTitle] = useState<PageTitle>();

  return (
    <PageTitleContext.Provider
      value={{
        pageTitle,
        setPageTitle
      }}>
      {children}
    </PageTitleContext.Provider>
  );
}

export function usePageTitleContext() {
    return useContext(PageTitleContext);
}
